import useUser from '@alltrails/context/hooks/useUser';
import { useExposureEvent } from '@alltrails/experiments';
import { useEffect } from 'react';

const useScrollAuthHoldoutExposureOnMount = () => {
  const user = useUser();
  const sendExposure = useExposureEvent('web-growth-rm-scroll-auth-holdout');

  useEffect(() => {
    if (!user) {
      sendExposure();
    }
  }, [sendExposure, user]);
};

export default useScrollAuthHoldoutExposureOnMount;
